import {
  ContentChildren,
  QueryList,
  Component,
  ContentChild,
  Input,
} from '@angular/core';
import { Projectable } from './projectable';
import { PgTemplatePageHost } from './template-page-host';
import { styleVariables } from '@progleasing/grit-core';

/*
    The following components are for the purpose of
    transcluding the contents of the layout into
    various slots for transclusion.

*/
export abstract class ProjectionHost {
  abstract get childTemplates(): QueryList<Projectable>;
}

@Component({
  selector: `pg-app-form-header, grit-origination-topbar`,
  template: `
    <ng-content></ng-content>
  `,
})
export class PgAppFormHeaderComponent {}

@Component({
  selector: `pg-app-form-footer, grit-origination-footer`,
  template: `
    <ng-content></ng-content>
  `,
})
export class PgAppFormFooterComponent {}

@Component({
  selector: 'pg-app-form-page-title, grit-origination-page-title',
  template: ``,
})
export class PgAppFormPageTitleComponent extends ProjectionHost {
  @ContentChildren(Projectable)
  childTemplates: QueryList<Projectable>;
}

@Component({
  selector: 'pg-app-form-page-body, grit-origination-page-body',
  template: ``,
})
export class PgAppFormPageBodyComponent extends ProjectionHost {
  @ContentChildren(Projectable)
  childTemplates: QueryList<Projectable>;
}

@Component({
  selector: 'pg-app-form-page-action, grit-origination-page-action',
  template: ``,
})
export class PgAppFormPageActionComponent extends ProjectionHost {
  @ContentChildren(Projectable)
  childTemplates: QueryList<Projectable>;
}
@Component({
  selector: 'pg-app-form-page, grit-origination-page',
  template: ``,
})
export class PgAppFormPageComponent extends ProjectionHost {
  @Input()
  key: string;

  @Input()
  backLinkText: string;

  @Input()
  backAction: Function | string;

  @Input()
  canActivate: (cur, next) => boolean | any;

  @ContentChild(PgAppFormPageTitleComponent)
  titleChild: PgAppFormPageTitleComponent;

  @ContentChild(PgAppFormPageBodyComponent)
  bodyChild: PgAppFormPageBodyComponent;

  @ContentChildren(Projectable)
  childTemplates: QueryList<Projectable>;
}

@Component({
  selector: 'pg-app-form-section-title, grit-origination-section-title',
  template: ``,
})
export class PgAppFormSectionTitleComponent extends ProjectionHost {
  @ContentChildren(Projectable, { descendants: true })
  childTemplates: QueryList<Projectable>;
}

@Component({
  selector: 'pg-app-form-section, grit-origination-section',
  template: ``,
  providers: [
    { provide: PgTemplatePageHost, useExisting: PgAppFormSectionComponent },
  ],
})
export class PgAppFormSectionComponent extends PgTemplatePageHost {
  getPages() {
    return this.pageChildren;
  }
  getSectionTitle() {
    return this.titleChild;
  }
  @ContentChildren(PgAppFormPageComponent, { descendants: true })
  pageChildren: QueryList<PgAppFormPageComponent>;

  @ContentChild(PgAppFormSectionTitleComponent)
  titleChild: PgAppFormSectionTitleComponent;

  @Input()
  gradientStopColor1 = styleVariables.blue300;

  @Input()
  gradientStopColor2 = styleVariables.blue500;

  @Input()
  sectionTitleContrastColor;
}
